import React from "react";
import "./modal-louder.scss"

export const ModalLouder: React.FC = () => (
  <div className="modal-louder">
    <div className="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
  </div>
);